
import React from "react";
import Logo from "../components/Logo";
import { Button } from "../components/ui/button";
import { Bell, Info } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { WaitlistDialog } from "@/components/WaitlistDialog";

const BoostCardsOnTheWay = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  
  // Check if user came from eateries page
  const fromEateriesPage = location.state && location.state.fromEateriesPage;

  return (
    <div className="min-h-[100dvh] flex flex-col items-center p-6">
      <div className="w-full max-w-4xl mx-auto">
        <Logo />
        <div className="mt-12 space-y-8 text-center">
          <h1 className="text-5xl font-bold bg-gradient-to-r from-black to-gray-700 bg-clip-text text-transparent animate-fade-up opacity-0" style={{ animationDelay: "0.2s" }}>
            Boost Cards Sold Out
          </h1>
          
          <h2 className="text-2xl font-semibold text-black animate-fade-up opacity-0" style={{ animationDelay: "0.3s" }}>
            All available Boost Cards for this location have been claimed!
          </h2>
          
          <div className="relative py-6 px-8 bg-[#D3E4FD] rounded-lg border-2 border-blue-300 shadow-lg animate-scale-in opacity-0" style={{ animationDelay: "0.4s" }}>
            <p className="text-lg text-gray-800">
              <span className="font-bold">Not To Worry!</span> We're working with management to issue more <span className="font-bold">Boost Cards</span>!
            </p>
          </div>

          <div className="mt-8 space-y-4 animate-fade-up opacity-0" style={{ animationDelay: "0.5s" }}>
            {!fromEateriesPage && (
              <div className="flex justify-center">
                <Button 
                  variant="outline"
                  onClick={() => navigate("/")}
                  className="text-gray-700 hover:text-gray-900 space-x-2"
                >
                  <Info className="w-5 h-5" />
                  <span>What is EatsBoost?</span>
                </Button>
              </div>
            )}

            <Button 
              onClick={() => setIsDialogOpen(true)}
              className="bg-eatsboost-orange hover:bg-eatsboost-orange/90 text-white space-x-2"
            >
              <span>Notify Me</span>
              <Bell className="w-5 h-5" />
            </Button>
            <p className="text-sm text-gray-600 mt-4">
              We will notify you once more Boost Cards have arrived
            </p>
          </div>
        </div>
      </div>

      <WaitlistDialog 
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
      />
    </div>
  );
};

export default BoostCardsOnTheWay;
